export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-text-color-c2ec56741ed7ceabfa15c739cd981f13.svg";